import { useState } from 'react';

export type DynamicLink = {
  destinationUrl: string;
};

export type GetDynamicLinkResult = {
  dynamicLink: DynamicLink;
};

export const useGetDynamicLink = () => {
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getDynamicLink = async (
    shortPath: string,
    screenWidth: number,
    screenHeight: number,
  ): Promise<GetDynamicLinkResult | undefined> => {
    setError(undefined);
    setIsLoading(true);

    const response = await fetch(
      `https://api.pushtrainingapp.com/dynamic-links/${shortPath}?sw=${screenWidth}&sh=${screenHeight}`,
      {
        method: 'GET',
      },
    ).catch(() => {
      setError(`Failed to fetch.`);
      return null;
    });

    setIsLoading(false);

    if (!response) {
      return undefined;
    }
    const responseBody = await response.json();
    setIsLoading(false);

    if (responseBody.error) {
      setError(responseBody.error.description);
      return undefined;
    }
    if (response.ok) {
      return responseBody.data;
    }
    throw Error('Unexpected API result.');
  };

  return { getDynamicLink, isLoading, error };
};
